import {Component, Input} from '@angular/core';
import {TooltipPanelPosition} from './tooltip';
import {NgClass} from '@angular/common';

@Component({
  standalone: true,
  selector: 'mc-tooltip-panel',
  templateUrl: './tooltip-panel.component.html',
  styleUrls: ['./tooltip-panel.component.scss'],
  imports: [NgClass],
})
export class TooltipPanelComponent {
  @Input() position: TooltipPanelPosition;
  @Input() forceOpen?: boolean;
  @Input() hideTriangle?: boolean;
  @Input() noHover?: boolean;
  @Input() disabled?: boolean = false;

  get tooltipPanelClass() {
    if (this.disabled) return 'no_hover';
    return `mc-tooltip-panel_${this.position} ${this.forceOpen ? 'active' : ''} ${
      this.hideTriangle ? 'triangle_hided' : ''
    } ${this.noHover ? 'no_hover' : ''}`;
  }
}
